import React from 'react';
import {ThemeProvider, withStyles} from '@material-ui/core/styles';
import theme from './theme';
import './commons/airgloss-font'
import RealTimeProvider from "./hocs/public-api/real-time/RealTimeProvider";
import AppHeader from "./AppHeader";
import ReadQueryString from "./utils/ReadQueryString";
import DevicesProvider from "./hocs/public-api/devices/DevicesProvider";
import HistoryProvider from "./hocs/public-api/history/HistoryProvider";
import DevicesGrid from "./DevicesGrid";
import AppFooter from "./AppFooter";

const styles = theme => ({
    root: {
        margin: theme.spacing(3)
    }
});

const App = ({classes, devices, ...props}) => {
    return (
        <ThemeProvider theme={theme}>
            <ReadQueryString>
                {({token, serials, title, provider}) => (
                    <RealTimeProvider token={token}>
                        <DevicesProvider token={token}>
                            <HistoryProvider token={token}>
                                <div className={classes.root}>
                                    <AppHeader
                                        title={title}
                                        provider={provider}
                                    />
                                    <DevicesGrid
                                        serials={serials}
                                    />
                                    <AppFooter />
                                </div>
                            </HistoryProvider>
                        </DevicesProvider>
                    </RealTimeProvider>
                )}
            </ReadQueryString>
        </ThemeProvider>
    );
};

export default withStyles(styles)(App);
